import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import "./chart.css";

function ChartBar2({
  data = [],
  geralValue = 0.0,
  categoryKey,
  valueKey,
  percentageKey,
  chartType = "bar",
  titleX,
  titleY,
  isHorizontal = false,
  seriesName = "Data",
  showPercentage = true,
}) {
  const sortedData = useMemo(
    () => data?.length ? [...data].sort((a, b) => showPercentage ? b[percentageKey] - a[percentageKey] : b[valueKey] - a[valueKey]) : [],
    [data, showPercentage, percentageKey, valueKey]
  );

  const categories = useMemo(
    () => sortedData.map((item) => item[categoryKey] ?? ""),
    [sortedData, categoryKey]
  );

  const series = useMemo(
    () => [{
      name: seriesName,
      data: showPercentage
        ? sortedData.map((item) => item[percentageKey])
        : sortedData.map((item) => item[valueKey]),
    }],
    [seriesName, showPercentage, sortedData, percentageKey, valueKey]
  );

  const options = useMemo(
    () => ({
      chart: { type: chartType },
      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: "end",
          horizontal: isHorizontal,
          distributed: true,
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => showPercentage ? `${val.toFixed(0)}%` : val,
      },
      xaxis: {
        categories,
        title: { text: titleX, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      yaxis: {
        title: { text: titleY, style: { color: "var(--text-50)" } },
        labels: {
          style: { colors: "var(--text-50)" },
          formatter: (val) => showPercentage ? `${val.toFixed(0)}%` : val,
        },
      },
      tooltip: {
        y: { formatter: (val) => showPercentage ? `${val.toFixed(2)}%` : val },
      },
      legend: { show: false },
      annotations: {
        yaxis: [{
          y: geralValue,
          borderColor: "#FF5733",
          label: {
            borderColor: "#FF5733",
            style: { color: "#fff", background: "#FF5733" },
            text: `Geral - ${geralValue.toFixed(1)}%`,
          },
        }],
      },
    }),
    [chartType, isHorizontal, showPercentage, categories, titleX, titleY, geralValue]
  );

  return (
    <Chart options={options} series={series} type={chartType} height="100%" width="100%" />
  );
}

export default memo(ChartBar2);
